module.exports = __webpack_public_path__ + "static/derrick-thomas-a9c464e9535b0607bf08e520937da2ba.jpeg";